import { ComparableSuite } from "./SuitesComparison";

export const prefilteredComparableSuites = (
  selectedSuiteCategory: string | undefined,
  suites: ComparableSuite[],
  maxNumberOfComparableSuites: number
): ComparableSuite[] => {
  if (!selectedSuiteCategory)
    return suites.slice(0, maxNumberOfComparableSuites);

  const selectedIndex = suites.findIndex(
    (s) => s.suiteCategory == selectedSuiteCategory
  );

  if (selectedIndex == 0) {
    return suites.slice(0, maxNumberOfComparableSuites);
  }

  if (selectedIndex == suites.length - 1) {
    return suites.slice(-maxNumberOfComparableSuites);
  }

  return suites.slice(
    selectedIndex - 1,
    maxNumberOfComparableSuites + (selectedIndex - 1)
  );
};
